import { useEffect, useState } from "react";
import { Badge, Card, Col, Collapse, InputGroup, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { isHTMLIdentifier } from "../../../utils/universalFunction";

const FieldErrorNotification = ({
  Show,
  Hide,
  Title,
  notificationData,
  tableRef,
  onMouseDown,
  dataEntryQueryNotificationDiscussionLoader,
  queryNotificationStatusButtonLoader,
  dataEntryQueryNotificationDiscussion,
  getStudySubjectFormFieldQueryNotificationDiscussionDataEntry,
  generateQueryNotificationStatusStudySubjectFormField,
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [fieldTab, setFieldTab] = useState("");

  useEffect(() => {
    if (Show && notificationData) {
      setFieldTab(notificationData?.fieldName);
      getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(notificationData?.siteId, notificationData?.subjectId, notificationData?.formId, notificationData?.queryId)
    }
  }, [Show, notificationData]);


  const getStatusBadge = (status) => {
    const statusMap = {
      "open": "danger",
      "re-open": "danger",
      "answered": "primary",
      "responded": "primary",
      "close": "success",
      "cancel": "warning",
    };
    return statusMap[status] || "secondary";
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="p-3">
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row className="mb-2">
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Site</small>
                    <div style={{ fontSize: "13px" }}>{notificationData?.siteName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Subject</small>
                    <div style={{ fontSize: "13px" }}>{notificationData?.subjectName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Event</small>
                    <div style={{ fontSize: "13px" }}>{notificationData?.eventName} {notificationData?.timePointLabel && `(${notificationData?.timePointLabel})`}</div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Form</small>
                    <div style={{ fontSize: "13px" }}>{notificationData?.formName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Version</small>
                    <div style={{ fontSize: "13px" }}>v{notificationData?.formVersion}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Form Type</small>
                    <div className="text-capitalize" style={{ fontSize: "13px" }}>{notificationData?.formType}</div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Field Label (Name)</small>
                    <div style={{ fontSize: "13px" }}>
                      {isHTMLIdentifier(notificationData?.mainFieldLabel || "") ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: notificationData?.mainFieldLabel,
                          }}
                        />
                      ) : (
                        notificationData?.mainFieldLabel
                      )} ({notificationData?.mainFieldName})
                    </div>
                  </Col>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Sub Field Label (Name)</small>
                    <div style={{ fontSize: "13px" }}>
                      {notificationData?.fieldLabel} ({notificationData?.fieldName})
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Sub Field Value</small>
                    <div style={{ fontSize: "13px" }}>
                      {notificationData?.fieldValue}
                    </div>
                  </Col>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Status</small>
                    <div>
                      <Badge bg={notificationData?.status === "open" ? "danger-subtle" : notificationData?.status === "cancel" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${notificationData?.status === "open" ? "text-danger" : notificationData?.status === "cancel" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{notificationData?.status}</Badge>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Raised by</small>
                    <div style={{ fontSize: "13px" }}>
                      {notificationData?.generatedByName}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Assigned to</small>
                    <div style={{ fontSize: "13px" }}>
                      {notificationData?.assignedToName}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Due Age</small>
                    <div style={{ fontSize: "13px" }}>
                      {notificationData?.notificationAge}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <div className="hstack justify-content-end">
              {(!StudyMode?.startsWith("SDV") && notificationData?.status === "open") &&
                <div className="hstack gap-2">
                  <Badge onClick={() => { if (!queryNotificationStatusButtonLoader) generateQueryNotificationStatusStudySubjectFormField(notificationData?.siteId, notificationData?.subjectId, notificationData?.schemaId, notificationData?.eventId, notificationData?.timePointUniqueId, notificationData?.formId, notificationData?.queryId, "close") }} bg={queryNotificationStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                    {queryNotificationStatusButtonLoader ? <div className="hstack gap-2">
                      <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                    </div>
                      : "Close Notification"
                    }
                  </Badge>
                </div>
              }
            </div>
            <div>
              <h6 style={{ fontSize: 14 }} className="fw-bold mb-3">Notification History & Audit</h6>
              {dataEntryQueryNotificationDiscussionLoader ?
                <div
                  className="hstack justify-content-center"
                  style={{ height: "calc(100vh - 580px)" }}
                >
                  <PageLoader />
                </div> :
                dataEntryQueryNotificationDiscussion.map((item, index) => (
                  <div key={index} className="mb-3">
                    <div className="d-flex align-items-start gap-3">
                      <div className="d-flex flex-column align-items-center">
                        <div style={{
                          width: "12px", height: "12px", borderRadius: "50%",
                          background: (item.status === "answered" || item.status === "responded") ? "#0d6efd" :
                            item.status === "close" ? "#198754" :
                              item.status === "cancel" ? "#d19916" :
                                (item.status === "open" || item.status === "re-open") ? "#ed0000" :
                                  "#787878",
                          marginTop: "4px"
                        }}>
                        </div>
                        {index < dataEntryQueryNotificationDiscussion?.length - 1 && (
                          <div style={{ width: "2px", height: "40px", background: "#dee2e6", margin: "4px 0" }}></div>
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div className="hstack gap-2 flex-wrap">
                          <span className="fw-bold text-capitalize">{item.actionStatus === "cancel" ? "cancelled" : item.actionStatus === "close" ? "closed" : item?.actionStatus}</span>
                          <Badge bg={`${getStatusBadge(item.status)}-subtle`} className={`text-${getStatusBadge(item.status)} rounded-1 text-capitalize`} style={{ fontSize: 9 }}>
                            {item.status === "cancel" ? "cancelled" : item.status === "close" ? "closed" : item?.status}
                          </Badge>
                          <small className="text-muted ms-auto">{item.commentedByName}, {item.commentedDT}</small>
                        </div>
                        <Card className="mt-2 border bg-light p-2 w-100">
                          <div className="mt-1" style={{ fontSize: "13px", color: "#212529" }}>
                            {item.comment}
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FieldErrorNotification;